import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ContentComponentForPopUpComponent } from 'ib/internetbank-core/ib-components/pop-ups/pop-up/pop-up.component';
import { BonusCodes } from 'ib/internetbank-core/ib-models/bonus-code.enum';

import { ProductId } from '../../../../common/models/product-id';
import { SelfTransferRouteUtils } from '../../../../sections/operations/transfers/route-utils/self-transfer.route-utils';

@Component({
	selector: 'app-bonus-transfer-type-popup',
	templateUrl: './bonus-transfer-type.content-component-for-popup-component.component.html',
	styleUrls: ['./bonus-transfer-type.content-component-for-popup-component.component.less'],
	imports: [RouterModule],
})
export class BonusTransferTypePopupComponent extends ContentComponentForPopUpComponent {

	@Input({ required: true })
	public productId: ProductId;

	@Input({ required: true })
	public programId: BonusCodes;

	public SelfTransferRouteUtils = SelfTransferRouteUtils;

	public close(): void {
		this.closePopup?.();
	}
}
